import React, { ReactNode } from 'react'
import { CSSTransition } from 'react-transition-group'

import './FadeTransition.css'

interface IFadeTransitionProps {
  children: ReactNode
  in: boolean
  isMountOnEnter?: boolean
}

export const FadeTransition = (props: IFadeTransitionProps) => {
  const { isMountOnEnter = false } = props

  return (
    <CSSTransition
      timeout={300}
      in={props.in}
      appear
      mountOnEnter={isMountOnEnter}
      classNames={'fade'}
    >
      {props.children}
    </CSSTransition>
  )
}
